module.exports = "/images/ny-street-3.jpg";